import { render, staticRenderFns } from "./mainFooter.vue?vue&type=template&id=c05a398e&scoped=true"
import script from "./mainFooter.vue?vue&type=script&lang=js"
export * from "./mainFooter.vue?vue&type=script&lang=js"
import style0 from "./mainFooter.vue?vue&type=style&index=0&id=c05a398e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05a398e",
  null
  
)

export default component.exports